import { render, staticRenderFns } from "./edit-package-modal.vue?vue&type=template&id=cd6133a8"
import script from "./edit-package-modal.vue?vue&type=script&lang=js"
export * from "./edit-package-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports